let searchTimeoutId = null;

const siezeReplacements = {
  chico: "ch",
  mediano: "M",
  grande: "G",
  "extra grande": "XG",
};

const search = {
  isWaiting: false,
  input: document.getElementById("search-query"),
  sortBy: document.getElementById("sort-by"),
  hitsByProductId: new Map(),
  state: {
    page: {
      container: document.getElementById("search-results-page"),
      query: null,
      from: 0,
      size: 20,
    },
    modal: {
      container: document.getElementById("search-results"),
      query: null,
      from: 0,
      size: 5,
    },
  },
  _ctx(ctx = "page") {
    return ctx === "modal" ? "modal" : "page";
  },
  indexHits(hits = []) {
    for (const hit of hits) {
      if (!hit) continue;
      const pid = String(hit.productId ?? "");
      if (!pid) continue;
      this.hitsByProductId.set(pid, hit);
    }
  },
  clear: (ctx) => {
    const k = search._ctx(ctx);
    const st = search.state[k];
    search.input.value = "";
    st.container.innerHTML = "";
  },
  set: (val) => {
    localStorage.setItem("isKeyword", true);
    search.input.value = val
    document.querySelector('.search__submit').click()
  },
  get: (ctx) => {
    // console.log('Search - Entra al get')
    const k = search._ctx(ctx);
    const st = search.state[k];
    let sort = null;
    if (k == "page") {
      switch (search.sortBy.value) {
        case "price-descending":
          sort = { field: "price", order: "desc" };
          break;
        case "price-ascending":
          sort = { field: "price", order: "asc" };
          break;
        case "created-descending":
          sort = { field: "datePublished", order: "desc" };
          break;
        default:
          sort = null;
          break;
      }
    }
    let query
    let searchObj1 = {}
    let searchObj2 = {}
    if (k === 'page') {
      query = st.query ?? (st.query = search.input.value.trim());
      const isKeyword = localStorage.getItem("isKeyword");
      searchObj1 = {
        query: st.query ?? (st.query = search.input.value.trim()),
        products: {
          facets:["*"],
          filter: query != st.query ? [] : search.facets.list,
          fields: ["name", "imageUrl", "url"],
          size: st.size,
          from: st.from,
        },
        keywords: { size: 8, fields: ["keyword", "_highlight.keyword", "_redirect"] },
      }
      if (sort != null) {
        searchObj1.products.sort = sort;
      }
      searchObj2 = {
        redirect: false,
        track: "serp",
      }
      //Para los ac-chip
      if (isKeyword) {
        searchObj2.isKeyword = true
        localStorage.removeItem("isKeyword");
      }
    }
    else {
      query = search.input.value.trim()
      searchObj1 = {
        query: search.input.value.trim(),
        products: {
          fields: ["name", "url"],
          size: st.size,
        },
        keywords: { size: 8, fields: ["keyword", "_highlight.keyword", "_redirect"] },
      }
      searchObj2 = {
        redirect: false,
        track: "autocomplete",
        // isKeyword: true,
      }
    }
    console.log(JSON.stringify(searchObj1),JSON.stringify(searchObj2))
    if (searchObj1.query.length > 1) {
      nostojs((api) => {
        // console.log('Debug')
      // console.log(query,st.query)
        if (query != st.query){ 
          st.from = 0;
          nostojs(api => { 
            api.recordSearchSubmit(query) 
          }) 
        }
        api.search(searchObj1, searchObj2)
          .then((response) => {
            // console.log('GET Search')
            // console.log(response)
            let allEmpty = true;
            for (let i = 0; i <= 4; i++) {
              const facet = search?.facets?.list?.[i];
              const values = facet?.value;
              if (Array.isArray(values) && values.length > 0) {
                allEmpty = false;
                break;
              }
            }
            if (
              k === 'page' &&
              allEmpty &&
              response.products.facets?.length > 0
            ) {
              const tallaOrder = [
                "XCH",
                "CH",
                "M",
                "G",
                "XG",
                "CHM",
                "MG",
                "UNITALLA",
                "SIN TALLA",
              ];
              search.facets.container.innerHTML = "";
              search.facets.list[0].value = [];
              search.facets.list[1].value = [];
              search.facets.list[2].value = [];
              search.facets.list[3].value = [];
              search.facets.list[4].value = [];
              for (const customFacet of response.products.facets) {
                if (customFacet.name != "shasa-color") {
                  search.facets.container.innerHTML += `
                    <details class="facets__details">
                      <summary>
                        <span class="facets__details-title">
                          ${customFacet.name}
                          <span class="facets__count-badge" style="display:none;"></span>
                        </span>
                        <svg class="icon icon-filter-two" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 1.5L6 5.5L2 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
                        </svg>
                      </summary>
                      <fieldset class="facets-wrap parent-wrap">
                        <ul class="facets__list">
                          ${customFacet.data
                            .slice()
                            .sort((a, b) => {
                              if (customFacet.field !== "skus.customFields.talla") return 0;

                              const aIndex = tallaOrder.indexOf(a.value.toUpperCase());
                              const bIndex = tallaOrder.indexOf(b.value.toUpperCase());

                              if (aIndex === -1 && bIndex === -1) return 0;
                              if (aIndex === -1) return 1;
                              if (bIndex === -1) return -1;

                              return aIndex - bIndex;
                            })
                            .map((facet) => {
                              const replacedFacet = facet.value
                                .trim()
                                .replace(/[^a-zA-Z]/g, "")
                                .toLowerCase();

                              const facetName = facets.es[replacedFacet] || facet.value;

                              return `
                                <li class="list-menu__item facets__item" title="${facet.value}">
                                  <label class="facets-checkbox">
                                    <input type="checkbox" class="facets-checkbox__hide"
                                      onchange="search.facets.set('${customFacet.field}', '${facet.value}', this.checked)">
                                    <span class="facets-checkbox__marker">
                                      <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10">
                                        <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2"/>
                                      </svg>
                                    </span>
                                    <span class="facets-checkbox__label">
                                      ${facetName}
                                    </span>
                                  </label>
                                </li>
                              `;
                            })
                            .join("")}
                        </ul>
                      </fieldset>
                    </details>
                  `;
                }
              }
              // Actualizar botón Apply existente
              const applyBtn = search.facets.container?.parentElement?.querySelector('button[type="submit"].facets__submit');
              if (applyBtn) {
                applyBtn.className = 'button button--primary button--full-width facets-apply-btn facets__submit facets__submit--disabled';
                applyBtn.setAttribute('disabled', '');
                applyBtn.setAttribute('aria-disabled', 'true');
                applyBtn.addEventListener('click', search.facets.applyFilters);
              }
              url.searchParams.set('q', response.query);
              window.history.replaceState({}, '', url);
            }
            const hits = response?.keywords?.hits?.map(h => h.keyword) || [];
            let wrap
            if (k === 'modal') {
              wrap = document.getElementById('search-autocomplete');
            }
            else {
              wrap = document.getElementById('search-page-autocomplete');
            }
            if (wrap) {

              wrap.innerHTML = '';
              hits.forEach(s => {
                const value = typeof s === 'string' ? s : (s.keyword || '');
                if (!value) return;
                if (value == search.input.value.trim()) return;

                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'ac-chip';
                btn.setAttribute('role', 'option');
                btn.textContent = value;

                btn.addEventListener('click', () => {
                  search.set(value);
                });

                wrap.appendChild(btn);
              });
            }
            if (k === 'page' && response.products.hits.length < 20) {
              document.getElementById('search-load-more').classList.add('d-none')
            }
            if (response.products.hits.length > 0) {
              search.indexHits(response.products.hits);
              if (st.from == 0) {
                // console.log('DEBUG FROM 0')
                // console.log(st)
                st.container.innerHTML = "";
              }
              for (const hit of response.products.hits) {
                const container = document.createElement("div");
                //// nsc = nosto search card
                const id = `card-${hit.productId}`;
                container.id = id;
                st.container.appendChild(container);
                new Card(hit.productId, id, "nostosearch");
              }
            } else if (st.from == 0) {
              st.container.innerHTML = "<h2>Sin resultados</h2>";
            }
            st.query = response.query;
          });
      });
    }
  },
  facets: {
    container: document.querySelector(".facets__details__wrapper"),
    list: [
      {
        field: "skus.customFields.talla",
        value: [],
      },
      {
        field: "customFields.shasa-color",
        value: [],
      },
      {
        field: "customFields.custom-fits",
        value: [],
      },
      {
        field: "customFields.custom-product_group_code",
        value: [],
      },
      {
        field: "customFields.custom-color",
        value: [],
      },
    ],
    set: (name, value, checked, isColor) => {
  const facet = name.split(".").at(-1);
  const position = search.facets.list.findIndex((f) => f.field.includes(facet));
  if (position === -1) return;

  const valueUppercase = (value ?? "").toString().toUpperCase().trim();

  const expandedValues = isColor
    ? (COLOR_FILTER_MAP[value] || COLOR_FILTER_MAP[valueUppercase] || [value])
        .map((v) => (v ?? "").toString().toUpperCase().trim())
        .filter(Boolean)
    : [valueUppercase];

  if (checked) {
    const current = new Set(search.facets.list[position].value || []);
    expandedValues.forEach((v) => current.add(v));
    search.facets.list[position].value = Array.from(current);
  } else {
    const toRemove = new Set(expandedValues);
    search.facets.list[position].value = (search.facets.list[position].value || []).filter(
      (v) => !toRemove.has(v)
    );
  }
  search.logSelectedFilters();
  search.updateFilterBadges();
  // NO llamar a search.get() aquí - cambiar a manual apply
},
    applyFilters: () => {
      const ctx = 'page'
      search.get(ctx);
    },
  },
  logSelectedFilters: () => {
    const selectedFilters = {};
    let hasFilters = false;
    search.facets.list.forEach((facet) => {
      if (facet.value.length > 0) {
        selectedFilters[facet.field] = facet.value;
        hasFilters = true;
      }
    });
    console.info('Filtros seleccionados:', selectedFilters);
    
    const applyBtn = search.facets.container?.parentElement?.querySelector('button[type="submit"].facets__submit');
    if (applyBtn) {
      if (hasFilters) {
        applyBtn.classList.remove('facets__submit--disabled');
        applyBtn.removeAttribute('disabled');
        applyBtn.setAttribute('aria-disabled', 'false');
      } else {
        applyBtn.classList.add('facets__submit--disabled');
        applyBtn.setAttribute('disabled', '');
        applyBtn.setAttribute('aria-disabled', 'true');
      }
    }
  },
  updateFilterBadges: () => {
    const container = search.facets.container;
    if (!container) return;
    
    const details = container.querySelectorAll('.facets__details');
    details.forEach((detail, index) => {
      const checkboxes = detail.querySelectorAll('input[type="checkbox"]:checked');
      let badge = detail.querySelector('.facets__count-badge');
      
      if (checkboxes.length > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'facets__count-badge';
          const title = detail.querySelector('.facets__details-title');
          if (title) title.appendChild(badge);
        }
        badge.textContent = checkboxes.length;
        badge.style.display = 'inline-block';
      } else {
        if (badge) {
          badge.textContent = '';
          badge.style.display = 'none';
        }
      }
    });
  },
  open: (id, url) => {
    nostojs((api) => {
      api.recordSearchClick("serp", { productId: id, url: url });
    });
    location.href = url+"?fromnostosearch=true";
  },
  loadMore: (ctx) => {
    if (!search.isWaiting) {
      const k = search._ctx(ctx);
      const st = search.state[k];
      // console.log('DEbug')
      // console.log(st)
      search.isWaiting = true;
      // console.log(st.from)
      // console.log(st.size)
      st.from += st.size;
      // console.log(st.from)
      search.get(ctx);
      setTimeout(() => {
        search.isWaiting = false;
      }, 1500);
    }
  },
  sort: (ctx) => {
    const k = search._ctx(ctx);
    const st = search.state[k];
    st.from = 0;
    search.get(ctx);
  },
};


const url = new URL(window.location.href);
if (url.pathname.includes("search")) {
  const ctx = 'modal'
  const urlQuery = url.searchParams.get("q");
  if (urlQuery) search.get(ctx);
  search.input.addEventListener("input", (event) => {
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => {
      search.get(ctx);
    }, 1000);
  });
  window.addEventListener("scroll", () => {
    const ctx = 'page'
    const k = search._ctx(ctx);
    const st = search.state[k];
    const rect = st.container.getBoundingClientRect();
    if (rect.bottom <= window.innerHeight) {}
  });
}
else {
  const ctx = 'modal'
  search.input.addEventListener("input", () => {
    // console.log('Search de home')
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => {
      search.get(ctx)
    }, 800);
  });
}

if (url.searchParams.get("source") === "serp") {
  setTimeout(() => {
    const url = new URL(window.location.href);
    const id = url.searchParams.get("product");
    const handle = url.origin + url.pathname;
    nostojs((api) => {
      api.recordSearchClick("serp", {
        productId: id,
        url: handle
      });
    });
    url.searchParams.delete('source');
    url.searchParams.delete('product');
    window.history.replaceState({}, '', url);
  }, 1000);
}
window.recordClick = (record, id) => {
  let hit
  if (record == 'category') {
    hit = category.hitsByProductId.get(id)
  }
  if (record == 'serp') {
    hit = search.hitsByProductId.get(id)
  }
  nostojs((api) => {
    api.recordSearchClick(record, hit);
  });
}